module.exports = __webpack_public_path__ + "img/candi-nav-1.477c51d1.svg";